<template>
  <div class="result page" v-touch:swipe.right="swipeLeft">
    <div class="progress label">{{ (round + 1) + '/' + questions.length }}</div>
    <div>
      <gigly :mouth="expression.mouth" :eyes="expression.eyes" style="max-height: 150px;" />
      <!-- <div class="tooltip" data-direction="bottom">
        <p class="feedback-heading tooltip__initiator">{{ feedbackTitle }}
          <img v-if="tooltip" :src="info_icon" class="info-circle">
        </p>
        <div v-if="tooltip" class="tooltip__item">
          {{ tooltip }}
         
        </div>
      </div> -->

      <p> {{ message_tip }}</p>
    </div>

    
    <!-- <section class="section" v-if="!trivia_id">
      <keep-alive>
        <component :is="activeView.component" :key="activeView.name" class="transition" />
      </keep-alive>
    </section> -->
    <div class="view-tracker">
      <n-button style="background-color: #fbb03b;max-height: 45px;
    margin-top: 25px;" title="Next" @click.native="advance" :is-loading="isLoading" />
    </div>
  </div>
</template>

<script>
import Gigly from "@/components/general/Gigly";
const FEEDBACK_WRONG = [
  "That's too bad",
  `Better luck next time...`,
  `No points for you`
];

const FEEDBACK_CORRECT = [
  `You're smashing it`,
  "Congratulations",
  "You are pro at this!",
  "You are incredible",
  `The smartest chap in the room`,
  "Incredible effort",
  "How exquisite",
  `More points for you`,
  `You're cracking it`
];

const RESULT_VIEWS = {
  graph: {
    name: "results",
    component: () => import("./result/Graph.vue")
  },
  leaderboard: {
    name: "leaderboard",
    component: () => import("./result/Leaderboard.vue")
  }
};

import Button from "./general/Button";
import { htmlEntity } from '.././htmlEntityMixin';
import { store } from "../store/store";
export default {
  mixins: [htmlEntity],
  components: {
    "n-button": Button,
    Gigly
  },
  data() {
    return {
      activeView: RESULT_VIEWS.graph,
      status: "Setting up...",
      info_icon: require("@/assets/information.svg")
    };
  },
  mounted() {
    window.scrollTo(0, document.body.scrollHeight);
  },
  computed: {
    trivia_id() {
      return this.$store.state.matchSlug == 717;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
    playerRound() {
      return this.$store.state.player.round
    },
    playerAnswer() {
      return this.$store.state.scores['playerOne'].history[this.round - this.playerRound]
    },
    feedbackTitle() {
      const maxWrong = FEEDBACK_WRONG.length;
      const maxCorrect = FEEDBACK_CORRECT.length;
      // Get a random feedback sentence for wrong answers
      const randomWrong = Math.floor(Math.random() * maxWrong);
      // Get a random feedback sentence for correct answer
      const randomCorrect = Math.floor(Math.random() * maxCorrect);
      // Get the status of the player's answer from the store
      const playerAnswer = this.playerAnswer;
      // Select feedback sentence based on player answer
      // return 'Thank you for your response.'.this.$store.state.message_tip
      return this.$store.state.message_tip;


      // console.log(this.$store.state.message_tip);


      if (this.question.type === 'poll' || this.question.type === 'Poll') {
        return 'Thank you for your response.'
      }
      if (this.question.type === 'Open-ended' || this.question.type === 'open_ended') {
        return 'Thank you for your response.'
      }
      return playerAnswer.correct
        ? `Correct! ${FEEDBACK_CORRECT[randomCorrect]}`
        : `Wrong! ${FEEDBACK_WRONG[randomWrong]}`;
    },
    expression() {
      return { eyes: "happy", mouth: "happy" };
      return this.playerAnswer.correct
        ? { eyes: "happy", mouth: "happy" }
        : { eyes: "default", mouth: "sad-open" };
    },
    // Access questions from store
    questions() {
      return this.$store.state.questions;
    },
    choices() {
      return this.questions[this.round].choices;
    },
    question() {
      return this.questions[this.round];
    },
    tooltip() {
      return this.question.tooltip;

      // console.log(this.question.tooltip);
    },
    message_tip() {
      return this.question.message_tip;

      // console.log(this.question.message_tip);

      // console.log(this.question.tooltip);
    },
    // Access round from store
    round() {
      return this.$store.getters.round;
      
    },
    correctAnswers() {
      const ICONS = ["Circle", "Star", "Triangle", "Square"];
      /*const choices =[{
        '_key':'1',
        'title':'blue',
        'isCorrect':false
      },
        {
          '_key':'2',
          'title':'blue',
          'isCorrect':false
        },
        {
          '_key':'3',
          'title':'blue',
          'isCorrect':false
        },
        {
          '_key':'4',
          'title':'blue',
          'isCorrect':true
        }
      ]*/
      this.choices.map((choice, index) => ({
        ...choice,
        index
      }));
      //console.log(this.choices);
      return this.choices
        .filter(choice => choice.answer)
        .map((choice, index) => {
          return {
            ...choice,
            icon: () => import(`./symbols/${ICONS[index]}Icon.vue`)
          };
        });
    }
  },
  methods: {
    advance() {
      // Proceed if less than number of rounds
      if (this.round <= (this.$store.state.questions.length - 2)) {
        this.$store.commit('pauseGame');
        this.$store.commit('incrementRound');
        this.$store.commit('playerClickedCard', false);
        this.$store.commit('setResults', false);
        if (this.$store.state.team_mode === 0) {
          this.$store.dispatch("notifyNextQuestion", this.$store.state.questions[this.round]);
        }
        if (this.round === Math.round(((this.$store.state.questions.length) / 2))) {
          if (this.$store.state.has_game) {
            if (this.$store.state.matchSlug != 199
              || this.$store.state.matchSlug != 130
              || this.$store.state.challenge_id != 46
              || this.$store.state.matchSlug != 332
              || this.$store.state.matchSlug != 331
              || this.$store.state.matchSlug != 323
              || this.$store.state.matchSlug != 384
              || this.$store.state.matchSlug != 433
              || this.$store.state.matchSlug != 476
              || this.$store.state.matchSlug != 628
              || this.$store.state.matchSlug != 806
            ) {
              this.$store.commit('setIsOnBreak', true);
            }
          }

        }
        if (this.$store.state.matchSlug == 995) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          }
          if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 774) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 853) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 806) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 6) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 822) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 6) {
            this.$store.commit('setIsOnBreak', true);
          }
        } if (this.$store.state.trivia.creator_id == 7358) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 838) {
          if (this.round == 1) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 3) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 846) {
          if (this.round == 2) {
            this.$store.commit('setIsOnBreak', true);
          } if (this.round == 4) {
            this.$store.commit('setIsOnBreak', true);
          }
        }

        if (this.$store.state.matchSlug == 433) {
          if (this.round == 5) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 560) {
          // if (this.$store.state.has_game =='video') {
          if (this.round == 1) {
            this.$store.commit('setIsOnBreak', true);
          }
          if (this.round == 3) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 199) {
          if (this.round == 3) {
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 130) {
          if (this.round == 3) {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 332) {
          if (this.round == 4) {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 331) {
          if (this.round == 4) {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 323) {
          if (this.round == 4) {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.$store.state.matchSlug == 476) {
          if (this.round == 3 || this.round == 8) {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }

        if (this.$store.state.matchSlug == 384) {
          if (this.round == 4) {
            //this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        }
        if (this.round === 2) {
          if (this.$store.state.mystery_boxes.has_mystery_boxes) {
            this.$store.commit('setMystery', true);
          }
        }
        if (this.$store.state.matchSlug == 628) {
          if (this.round === 2) {

            this.$store.commit('setIsOnBreak', true);

          }
          if (this.round === 3) {

            this.$store.commit('setIsOnBreak', true);

          }
        }

      } else {
        let vm = this;
        console.log('Here')
        if (this.$store.state.challenge_id == 46) {
          if (this.$store.state.has_game == 'video') {
            this.$store.commit('njugush_video', true);
            this.$store.commit('setIsOnBreak', true);
          }
        } else {
          setTimeout(function () {
            vm.$store.commit('isGameOver');
          }, 1500);
        }

      }
    },
    swipeLeft() {
      if (this.activeView.name === "leaderboard") {
        this.activeView = RESULT_VIEWS.graph;
      } else {
        return;
      }
    },
    swipeRight() {
      if (this.activeView.name === "results") {
        this.activeView = RESULT_VIEWS.leaderboard;
      } else {
        return;
      }
    }
  }
};
</script>
<style>
.info-circle {
  width: 15px;
}

.tooltip {
  position: relative;
}

.tooltip__item {
  position: absolute;
  min-width: 300px;
  padding: 20px;
  visibility: hidden;
  opacity: 0;
  background: white;
  transition: all 0.25s cubic-bezier(0, 0, 0.2, 1);
  color: #323232;
  border: 1px solid #cecece;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0 2px 1px #bcbcbc;
  z-index: 4;
}

.tooltip__item:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

.tooltip__initiator {
  cursor: pointer;
  z-index: 5;
}

.tooltip[data-direction=left] .tooltip__initiator:hover~.tooltip__item {
  transform: translate3d(0, -50%, 0);
  visibility: visible;
  opacity: 1;
}

.tooltip[data-direction=left] .tooltip__item {
  top: 50%;
  right: calc(100% + 1em);
  transform: translate3d(15px, -50%, 0);
}

.tooltip[data-direction=left] .tooltip__item:after {
  top: 50%;
  right: -0.5em;
  transform: translate3d(0, -50%, 0);
  border-width: 0.5em 0 0.5em 0.5em;
  border-color: transparent transparent transparent white;
  -webkit-filter: drop-shadow(1px 2px 1px #bcbcbc);
  filter: drop-shadow(1px 2px 1px #bcbcbc);
}

.tooltip[data-direction=bottom] .tooltip__initiator:hover~.tooltip__item {
  transform: translate3d(-50%, 0, 0);
  visibility: visible;
  opacity: 1;
}

.tooltip[data-direction=bottom] .tooltip__item {
  top: calc(100% + 1em);
  left: 50%;
  transform: translate3d(-50%, -15px, 0);
}

.tooltip[data-direction=bottom] .tooltip__item:after {
  top: -0.5em;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  border-width: 0 0.5em 0.5em 0.5em;
  border-color: transparent transparent white transparent;
  -webkit-filter: drop-shadow(1px 2px 1px #bcbcbc);
  filter: drop-shadow(1px -1px 1px #bcbcbc);
}

.fa.fa-info-circle {
  font-size: 38px;
  color: #21606b;
}

body {
  margin: 0;
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  background: #dadada;
  font-family: "Roboto", sans-serif;
}

main {
  flex: 1 1 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
</style>
<style lang="sass" scoped>
@import '../styles/symbols.sass'
.result
  display: grid
  grid-template-rows: min-content min-content auto min-content

.question
  margin: 0.5rem 0
  font-size: $font-size-large
  @media screen and (min-height: 667px)
    font-size: $font-size-xlarge
  @media screen and (min-height: 812px)
    font-size: $font-size-xxlarge
  @media screen and (max-width: 320px)
    font-size: $font-size-medium
  &.long
    font-size: $font-size-medium


.correct-answers
  text-align: center
  padding-bottom: 0.5rem

  .label
    text-transform: uppercase
    font-size: $font-size-small
    padding: 0.5rem 0

  .answers
    display: flex
    justify-content: center

  .answer
    display: flex
    padding: 0 1rem
    align-items: center
    font-size: $font-size-base

    .symbol
      display: flex
      padding: 0 0.25rem

    .symbol svg
      height: $font-size-base

.section
  display: grid
  overflow: hidden
  max-height: 100%
  min-height: 0
  grid-template-columns: 1fr
  grid-template-rows: 1fr

  .transition
    grid-column: 1
    grid-row: 1

.view-tracker
  justify-self: flex-end
  display: flex
  justify-content: center
  width: 100%
  margin: 0.5rem 0 1rem

  .view-dot
    height: 0.5rem
    width: 0.5rem
    background: $color-gray
    border-radius: 50%
    margin: 0 0.25rem
    transition: all .7s ease-in-out

    &.is-active
      transform: scale(1.1)
      background: $color-gray--darker

</style>
